export const resolveHierarchyDestination = ({
  unit = "KA",
  formation = "",
  branch = "",
  subBranch = "",
  section = "",
} = {}) => {
  if (formation === "HQ KA") {
    return {
      unit,
      unitBranch: branch === "DHQ" ? "DHQ" : "",
      branch: subBranch || branch,
      subBranch: section || "",
    };
  }

  if (formation === "KAHAWA GARRISON" && branch === "AHQ SIG BN") {
    return {
      unit,
      unitBranch: branch,
      branch: formation,
      subBranch: subBranch || section,
    };
  }

  if (formation === "TRAINING INSTITUTIONS" && branch === "KMA") {
    return {
      unit,
      unitBranch: subBranch ? `KMA > ${subBranch}` : "",
      branch: formation,
      subBranch: section || subBranch || branch,
    };
  }

  return {
    unit,
    unitBranch: subBranch || section || "",
    branch: formation,
    subBranch: branch,
  };
};

